.context-menu(
    :style.left='contextMenu.x+"px"',
    :style.top='contextMenu.y+"px"',
    
    al-if='contextMenu.visible'
)
  .search.item(al-if='contextMenu.searchBar')
    input(al-value='filter')
  .item(al-repeat='item in contextMenu.searchItems(filter)',
    al-item
    )
    | {{item}}